import React from "react";
import { motion } from "framer-motion";
import { portfolioData } from "../data/portfolioData";

const Certifications = () => {
  const { certifications, sections } = portfolioData;

  if (!certifications?.length) return null;

  return (
    <section id="certifications" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">{sections.certificationsTitle}</h2>
        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {certifications.map((cert, index) => (
            <motion.article
              key={`${cert.name}-${index}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              className="rounded-xl border border-slate-200 bg-white/80 p-5 shadow-sm"
            >
              <h3 className="text-base font-semibold text-slate-900">{cert.name}</h3>
              <p className="mt-2 text-sm text-slate-700">{cert.issuer}</p>
              <p className="mt-1 text-xs font-semibold uppercase tracking-[0.15em] text-indigo-700">
                {cert.duration}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
